import { BordButton } from 'bord-design-system';

import './CustomerChatOpenButton.scss';

interface ICustomerChatOpenButton {
  onClick: () => void;
  alignWithOrderTabs?: boolean;
}

const CustomerChatOpenButton = ({ onClick, alignWithOrderTabs = false }: ICustomerChatOpenButton) => {
  const classNames = ['customerChatOpenButton', alignWithOrderTabs ? 'customerChatOpenButtonOrderOffset' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <BordButton
      label="Chat con el cliente"
      onClick={onClick}
      bordButtonStyle="outlined"
      buttonIconOne="messageSquare"
      customHeight="auto"
      customFontSize="1.2rem"
      customClassName={classNames}
    />
  );
};

export default CustomerChatOpenButton;
